var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('v-container',{attrs:{"fluid":""}},[_c('sidemenu'),_c('navbar'),_c('v-main',{staticClass:"mx-0 mx-lg-2"},[_c('div',{staticClass:"main-container"},[_c('router-view')],1),_c('app-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }